


















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class VualtoFooter extends Vue {
    private links: Array<{label: string, url: string}> =
        [
            {label: 'About Us', url: 'https://vualto.com'},
            {label: 'Products', url: 'https://vualto.com'},
            {label: 'Contact Us', url: 'https://vualto.com'},
        ];
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/layout/VualtoFooter.vue